// Thèmes proposés pour les articles (filtres de la page Analyses + choix dans l'admin)
export const ARTICLE_CATEGORIES = [
  { id: "crypto", label: "Crypto" },
  { id: "actions", label: "Actions" },
  { id: "obligations", label: "Obligations" },
  { id: "matieres", label: "Matières premières" },
];
// Libellés affichés (avec accents), y compris pour les anciennes catégories encore présentes en base
export const CATEGORY_LABEL = {
  crypto: "Crypto",
  actions: "Actions",
  obligations: "Obligations",
  matieres: "Matières premières",
  marches: "Marchés",
  strategie: "Stratégie",
  analyse: "Analyse",
  actualite: "Actualité",
};
export const categoryLabel = (id) => CATEGORY_LABEL[id] || id;
